import { render, staticRenderFns } from "./FreezingSingleProcess.vue?vue&type=template&id=6041cb21&"
import script from "./FreezingSingleProcess.vue?vue&type=script&lang=js&"
export * from "./FreezingSingleProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports